import type { GridColDef } from '@mui/x-data-grid';
import type { Customer } from '@weft/types';
import { compareDatesDescending, formatDate } from 'apps/app/src/utils/date';

const CUSTOMER_COLUMN_KEYS = Object.freeze({
  NAME: 'name',
  EXTERNAL_ID: 'externalId',
  CREATED_AT: 'createdAt',
} satisfies Record<string, keyof Customer>);

export const ANONYMOUS_CUSTOMERS_COLUMNS: GridColDef<Customer>[] = [
  {
    field: CUSTOMER_COLUMN_KEYS.EXTERNAL_ID,
    headerName: 'External ID',
    headerClassName: 'text-sm',
    headerAlign: 'center',
    align: 'center',
    cellClassName: 'pl-10',
    width: 160,
    valueGetter: (params) => params.row.externalId ?? '--',
  },
  {
    field: CUSTOMER_COLUMN_KEYS.NAME,
    headerName: 'Name',
    headerClassName: 'text-sm',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (params) => params.row.name,
  },
  {
    field: CUSTOMER_COLUMN_KEYS.CREATED_AT,
    headerName: 'Created at',
    headerClassName: 'text-sm',
    flex: 1,
    width: 400,
    headerAlign: 'left',
    align: 'left',
    renderCell: ({ row }) => formatDate(row.createdAt),
    sortComparator: (firstDate, secondDate) => compareDatesDescending(firstDate, secondDate),
  },
];
